/*
 * Jira Ticket:
 * Created Date: Thu, 10th Dec 2020, 15:05:38 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuItemLink, getResources, useTranslate } from 'react-admin';
// import SubMenu from './SubMenu';
import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';
import inflection from 'inflection';
import classnames from 'classnames';
// import { ExpandMore } from '@material-ui/icons';
import { menuStyles } from 'styles';
import { colors } from 'theme';
import { partition } from 'utils';
import { isResourceCurrentRoute } from 'utils/validation';
import { chain } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({ icon, isResourceSelected }) => {
  return (
    <FontAwesomeIcon
      style={{
        color: isResourceSelected ? colors.darkBlueGrey : null,
      }}
      icon={icon}
    />
  );
};

const translatedResourceName = (resource, translate) =>
  translate(`resources.${resource.name}.name`, {
    smart_count: 2,
    _:
      resource.options && resource.options.label
        ? translate(resource.options.label, {
            smart_count: 2,
            _: resource.options.label,
          })
        : inflection.humanize(inflection.pluralize(resource.name)),
  });

const AdminMenu = ({
  resources,
  onMenuClick,
  translate,
  sidebarIsOpen,
  currentPathname,
}) => {
  console.log({resources})
  return resources.map((resource) => {
    const isResourceSelected = isResourceCurrentRoute(
      resource.name,
      currentPathname
    );
    if (
      resource.options &&
      !resource.options.excludeFromMenu &&
      !resource.options.isHidden
    )
      return (
        <MenuItemLink
          key={resource.name}
          to={(resource.options && resource.options.to) || `/${resource.name}`}
          primaryText={
            translatedResourceName(resource, translate) || resource.name
          }
          leftIcon={
            resource.icon ? (
              <Icon
                isResourceSelected={isResourceSelected}
                icon={resource.icon}
              />
            ) : null
          }
          onClick={onMenuClick}
          sidebarIsOpen={sidebarIsOpen}
        />
      );
  });
};

const CustomMenu = (props) => {
  // get the user's current location
  const { pathname: currentPathname } = useLocation();
  const {
    classes,
    className,
    dense,
    hasDashboard,
    onMenuClick,
    logout,
    ...rest
  } = props;
  const menuClasses = menuStyles();
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  const translate = useTranslate();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  // will have the submenu open if the user is on one of the submenu routes
  const [subMenuOpen, setSubMenuOpen] = useState(undefined);

  const [subMenuResources, mainMenuResources] = partition(
    resources,
    (resource) => resource.options && resource.options.subMenu
  );

  const sortedMainMenuResources = chain(mainMenuResources)
    .sortBy('options.menuIndex')
    .value();

  const subMenuResourcesPaths = subMenuResources.map(
    (resource) => `/${resource.name}`
  );

  const handleToggle = () => {
    setSubMenuOpen(!subMenuOpen);
  };

  useSelector((state) => state.router.location.pathname);

  useEffect(() => {
    let getInitialSubMenuState =
      subMenuResourcesPaths.includes(currentPathname);
    if (subMenuOpen === undefined && subMenuResourcesPaths.length > 0) {
      setSubMenuOpen(getInitialSubMenuState);
    }
  }, [subMenuResourcesPaths, subMenuOpen]);

  return (
    <div className={classnames(menuClasses.main, className)} {...rest}>
      <AdminMenu
        resources={sortedMainMenuResources}
        onMenuClick={onMenuClick}
        translate={translate}
        sidebarIsOpen={open}
        currentPathname={currentPathname}
      />
      {/* add in sub menu if needed - example */}
      {/* <SubMenu
        handleToggle={handleToggle}
        isOpen={subMenuOpen}
        sidebarIsOpen={open}
        name={translatedResourceName({ name: 'subMenu' }, translate)}
        key={'resourcesSubMenu'}
        icon={<ExpandMore />}
        dense={true}
      >
        <AdminMenu
          resources={subMenuResources}
          onMenuClick={onMenuClick}
          dense={true}
          translate={translate}
        />
      </SubMenu> */}
      {isXSmall && logout}
    </div>
  );
};

export default CustomMenu;
